export const CaseTable = () => {
  return <></>;
};
